module.exports = __webpack_public_path__ + "static/media/freightconfig.1a560334.xlsx";